import { FC, useMemo } from 'react';
import { useAtomValue } from 'jotai';
import BreadcrumbsNavigation from '~/components/breadcrumbs-navigation';
import { $DiscoverBreadcrumbs } from 'shared/atoms';
import { $CurrentDiscoverKeyword, $CurrentDiscoverStandardKeyword } from '../../shared/atom';

export const DiscoverBreadcrumbs: FC = () => {
  const keyword = useAtomValue($CurrentDiscoverKeyword);
  const standardKeyword = useAtomValue($CurrentDiscoverStandardKeyword);

  const { breadcrumbs = '' } = useAtomValue($DiscoverBreadcrumbs(keyword as string));

  const list = useMemo(() => {
    const list = breadcrumbs.split(',');

    if (list.length > 1) {
      const lastWordLowerCase = list[list.length - 1].replace(/[A-Z]/g, (char) => char.toLowerCase());

      if (lastWordLowerCase === keyword) {
        list[list.length - 1] = standardKeyword;
      }
    }

    return list;
  }, [breadcrumbs]);

  return <>{breadcrumbs.length > 0 && <BreadcrumbsNavigation list={list} />}</>;
};
